import decode           from 'jwt-decode';
import uuid             from 'react-native-uuid';
import moment           from 'moment';
import { AwsConstants } from './environment';

const ID_TOKEN_KEY      = 'id_token';
const ACCESS_TOKEN_KEY  = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

const CHAT_ID           = 'chat_user_id';
const REFRESHING_TOKEN  = 'REFRESHING_TOKEN';

export function login() {
  window.location = AwsConstants.AuthorizerHost + '?id=' + AwsConstants.Id + '&redirect=' + encodeURIComponent(window.location.hash.replace("#/", ""));
}

export function redirect(redir) {
  window.location = AwsConstants.AuthorizerHost + '?id=' + AwsConstants.Id + '&redirect=' + encodeURIComponent(redir);
}

export function isAccessToken() {
  return getParameterByName('access_token');
}

export function callback() {
  var redirect = getParameterByName('redirect');
  console.log('redirect => ' + redirect);
  if (redirect) {
    window.location.href = "/#/" + redirect;
  }
  else {
    window.location.href = "/#/catalog";
  }
}

export function logout() {
  clearIdToken();
  clearAccessToken();
  clearRefreshToken();
  window.location.href = "/";
}

export function requireAuth(nextState, replace) {
  if (!isLoggedIn()) {
    replace({pathname: '/'});
  }
}

export function getIdToken() {
  return sessionStorage.getItem(ID_TOKEN_KEY);
}

export function getAccessToken() {
  return sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return sessionStorage.getItem(REFRESH_TOKEN_KEY);
}

export function attachAuth() {
  var token = getAccessToken();
  if (token && token !== "null") {
    return new Headers(
    {
      'content-type': 'application/json',
      'Authorization': getAccessToken() + ' ' + AwsConstants.Id
    });
  }
  else {
    return new Headers(
    {
      'content-type': 'application/json'
    });
  }
}

// Get and store refresh_token in local storage
export function setRefreshToken() {
  let refreshToken = getParameterByName('refresh_token');
  if (refreshToken) {
    sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
}

// Get and store access_token in local storage
export function setAccessToken() {
  let accessToken = getParameterByName('access_token');
  if (accessToken) {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  }
}

// Get and store id_token in local storage
export function setIdToken() {
  let idToken = getParameterByName('id_token');
  if (idToken) {
    sessionStorage.setItem(ID_TOKEN_KEY, idToken);
  }
}

export function isLoggedIn() {
  const idToken = getIdToken();
  return !!idToken && !isTokenExpired(idToken);
}

export function isAdmin() {
  const idToken = getAccessToken();
  return !!idToken && isInRole(idToken, AwsConstants.Admin);
}

export function isInRoleFromToken(role) {
  const idToken = getAccessToken();
  return !!idToken && isInRole(idToken, role);
}

export function attributeFromToken(attr) {
  if (isLoggedIn()) {
    const idToken = getAccessToken();
    const token = decode(idToken);
    return token[attr];
  }
  return null;
}

export function chatUserId() {
  var id = localStorage.getItem(CHAT_ID);
  if (!id) {
    id = uuid.v4();
    localStorage.setItem(CHAT_ID, id);
  }
  
  return id;
}

export function jwt({ dispatch, getState }) {
  return (next) => (action) => {  
    // only worry about expiring token for async actions
    if (typeof action === 'function') {
      // decode jwt so that we know if and when it expires
      const idToken = getIdToken();
      var tokenExpiration = getTokenExpirationDate(idToken);

      if (tokenExpiration && (moment(tokenExpiration) - moment(Date.now()) < 300000)) {
        // make sure we are not already refreshing the token
        if (!getState().auth.auth.token) {
          return refreshToken(dispatch).then(() => next(action));
        } else {
          return getState().auth.auth.token.then(() => next(action));
        }
      }
    }
  
    return next(action);
  };
}

// --------- PRIVATE ---------

function setAccessTokenData(token) {
  sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
}

function setIdTokenData(token) {
  sessionStorage.setItem(ID_TOKEN_KEY, token);
}

function clearIdToken() {
  sessionStorage.removeItem(ID_TOKEN_KEY);
}

function clearAccessToken() {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
}

function clearRefreshToken() {
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name) {
  let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function isInRole(encodedToken, r) {
  if (!encodedToken) 
    return false;
  const token = decode(encodedToken);
  console.log('token roles (' + (new Date().toLocaleString()) + '):');
  console.log(JSON.stringify(token.role));
  var found = false;
  if (r) {
    var roles = r.split(',');
    for (var i = 0; i < roles.length; i++) {
      var role = roles[i];
      if (findIndex(token, role)) {
        found = true;
      }
    }
  }
  
  return found;
}

function findIndex(token, role) {
  console.log('Looking for role: ' + role);
  return token.role.some(item => role && role.toLowerCase() === item.toLowerCase());
}

function getTokenExpirationDate(encodedToken) {
  var invalid = new Date(-8640000000000000);
  if (!encodedToken || encodedToken === 'undefined') return invalid;
  const token = decode(encodedToken);
  if (!token.exp) { return invalid; }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
}

function refreshToken(dispatch) {
  // console.log('starting refresh token...');
  var freshTokenPromise = fetchJWTToken()
    .then(t => {
      dispatch({
        type: REFRESHING_TOKEN,
        freshTokenPromise: false
      });

      return t.token ? Promise.resolve(t.token) : Promise.resolve(null);
    })
    .catch(e => {
      console.log('error refreshing token', e);

      dispatch({
        type: REFRESHING_TOKEN,
        freshTokenPromise: false
      });
      
      return Promise.reject(e);
    });

  dispatch({
    type: REFRESHING_TOKEN,

    // we want to keep track of token promise in the state so that we don't try to refresh
    // the token again while refreshing is in process
    freshTokenPromise
  });

  return freshTokenPromise;
}

function fetchJWTToken() {
  var promise = new Promise(function(resolve, reject) {
    
    var json = {
      'client_id': AwsConstants.Id,
      'refresh_token': getRefreshToken()
    };
    
    if (json.refresh_token) {
      fetch(AwsConstants.WebApiHost + 'token/refresh', {
        method: 'post',
        body: JSON.stringify(json)
      }).then(promise => {
        promise.json()
          .then(result => {
            if (result.access_token && result.id_token) {
              setAccessTokenData(result.access_token);
              setIdTokenData(result.id_token);
              resolve({token: result.access_token});    
            }
            else {
              clearAccessToken();
              clearIdToken();
              clearRefreshToken();
              resolve({token: null});  
            }
          })
          .catch((ex) => {
            clearAccessToken();
            clearIdToken();
            clearRefreshToken();
            resolve({token: null});
          });
      })
      .catch((ex) => {
        clearAccessToken();
        clearIdToken();
        clearRefreshToken();
        resolve({token: null});
      });
    }
    else {
      resolve({token: null});
    }
  });
  
  return promise;
}
